import React, { Fragment } from "react";
import store from "Store";

const T = ({ translations, props }) => {
    const { children, ...rest } = props;

    // Default to non-translated key
    let translatedValue = children;

    if (translations && translations[children]) {
        translatedValue = translations[children];

        for (const [key, value] of Object.entries(rest)) {
            const reg = new RegExp(`{{${key}}}`, "g");
            translatedValue = translatedValue.replace(reg, value);
        }
    }

    return <Fragment>{translatedValue}</Fragment>;
};

export const translate = (key, props) => {
    const { translations } = store.getState().locale;

    // Default to non-translated key
    let translatedValue = key;

    if (translations && translations[key]) {
        translatedValue = translations[key];

        if (props) {
            Object.keys(props).forEach(prop => {
                translatedValue = translatedValue.replace(`{{${prop}}}`, props[prop]);
            });
        }
    }

    return translatedValue;
};

export default T;



// WEBPACK FOOTER //
// ./src/components/Common/TranslateContainer/Translate.js